<template>
  <div class="modal-overlay" @click.self="modalStore.closeAllModals()">
    <div class="modal-window">
      <div class="modal-content">
        <div class="modal-text-container">
          <h2 class="modal-title">Восстановление пароля</h2>

          <!-- 📞 Телефон -->
          <PhoneInput
            v-model="phone"
            :disabled="isLoading"
            @valid="isPhoneValid = $event"
            placeholder="+7 900 000-00-00"
          />

          <!-- Новый пароль -->
          <input
            v-model="newPassword"
            class="modal-input"
            type="password"
            placeholder="Новый пароль"
            :disabled="isLoading"
            @keyup.enter="requestReset"
          />

          <!-- Кнопка отправки -->
          <button
            class="button-1"
            @click="requestReset"
            :disabled="isLoading || !isFormValid"
            :class="{ loading: isLoading }"
          >
            <span>{{ isLoading ? 'Отправляем...' : 'Отправить запрос' }}</span>
          </button>

          <!-- Уведомление -->
          <div v-if="notification" class="modal-toast">
            {{ notification }}
          </div>
        </div>
      </div>

      <button class="modal-close" @click="modalStore.closeAllModals()">✖</button>
    </div>
  </div>
</template>

<script>
import PhoneInput from '@/components/modals/PhoneInput.vue'
import { useModalStore } from "@/stores/modals"
import { useReCaptcha } from 'vue-recaptcha-v3'

export default {
  name: 'RestorePasswordModal',

  components: {
    PhoneInput
  },

  setup() {
    const modalStore = useModalStore()
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
    return { modalStore, executeRecaptcha, recaptchaLoaded }
  },

  data() {
    return {
      phone: '',              // ← PhoneInput сам поставит +7 при необходимости
      newPassword: '',
      isPhoneValid: false,
      isLoading: false,
      notification: '',
      notifyTimer: null
    }
  },

  computed: {
    isFormValid() {
      return this.isPhoneValid && this.newPassword.length >= 4
    }
  },

  methods: {
    showToast(msg, duration = 5000) {
      this.notification = msg
      clearTimeout(this.notifyTimer)
      this.notifyTimer = setTimeout(() => {
        this.notification = ''
      }, duration)
    },

    async requestReset() {
      if (this.isLoading || !this.isFormValid) return

      this.isLoading = true

      // phone уже в формате +79161234567 благодаря PhoneInput
      const formattedPhone = this.phone

      try {
        await this.recaptchaLoaded()
        const recaptchaToken = await this.executeRecaptcha('restore_password_request')

        const formData = new FormData()
        formData.append('phone', formattedPhone)
        formData.append('new_password', this.newPassword)
        formData.append('recaptcha_token', recaptchaToken)

        const res = await fetch('https://dancerus.ru/api/restore_password_request.php', {
          method: 'POST',
          body: formData
        })

        const data = await res.json()

        if (data.status === 'success') {
          this.showToast('Запрос отправлен! Подтверди в Telegram.', 7000)
          setTimeout(() => this.modalStore.openLoginModal(), 7000)
        } else {
          this.showToast(data.message || 'Ошибка')
        }
      } catch (err) {
        console.error(err)
        this.showToast('Ошибка сети или reCAPTCHA')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use "@/styles/mixins.scss";
</style>